import { AnalyticsBrowser } from '@segment/analytics-next'

export const analytics = new AnalyticsBrowser()
